/**
 * External dependencies
 */
import React from "react";

/**
 * Internal dependencies
 */
import FilterLoader from "./FilterLoader";

const FiltersLoader = ({ numOfItems = 2, itemProps }) => {
	let items = [];

	for (let i = 0; i < numOfItems; i++) {
		items.push(<FilterLoader key={i} {...itemProps} />);
	}

	return <>{items}</>;
};

export default FiltersLoader;
